module.exports = __webpack_public_path__ + "static/media/responsibility-body-bg-desktop.91265787.png";